module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/GlobalReachLogo-eaab954e5220c33c94000890b47b9e3d.jpg";